<template>
    <div class="grid grid-cols-5 w-full">
        <div class="col-span-2 p-2">

            <div class="bg-gray-50 text-sm border-2 border-gray-200 rounded-lg p-2 flex justify-between">
               <p>Uploaded brand name: </p> 
               <p>{{ retailerData.retailerName }}</p>
            </div>

            <div class="mt-2 text-sm bg-gray-50 border-2 border-gray-200 rounded-lg p-2 flex justify-between">
               <p>Uploaded brand website:</p> 
               <p>{{ retailerData.retailerWebsite }}</p>
            </div>

            <CustomInput v-model="enrichmentData.description" class="w-full mt-1" type="text"
                placeholder="Boogi Technologies LTD on 07/10/2024" label="Bank description text" />

            <CustomButton :disabled="enrichmentData.description == ''" class="mt-5" text="Test description" type="action" @click="enrichTransaction" />

        </div>
        <div v-if="transactionData != undefined" class="col-span-3 p-2 justify-center">
            <div class="bg-[#F5F2FB] px-3 py-4 rounded-lg bg-opacity-60 grid gap-2">

            <div v-if="transactionData != undefined">
                <div class="mb-4">
                        <p class="mb-1 text-sm font-medium">Enriched merchant information:</p>
                        <div class="flex justify-start items-center px-2 py-2 gap-2 w-full bg-white shadow-sm rounded-xl  border border-gray-300">
                            <img class="object-contain w-[50px] h-[50px] rounded-lg border border-gray-200 bg-white"
                                :src="transactionData.enrichedCreditorData.logo" />
                            <div class="">
                                <p class="font-medium text-normal">{{ transactionData.enrichedCreditorData.merchant }}</p>
                                <p class="-mt-1">
                                    <a class="text-sm cursor-pointer hover:underline" :href="transactionData.enrichedCreditorData.website" target="_blank">
                                        {{transactionData.enrichedCreditorData.website}}
                                    </a>
                                </p>
                            </div>
                        </div>
                </div>

                <div class="grid grid-cols-2 gap-x-1 w-full">
                    <div class="">
                        <p class="mb-1 text-sm font-medium">Retailers website:</p>
                        <p class="w-full py-3 px-2 text-sm bg-white border border-gray-300">
                            <a class="text-sm cursor-pointer hover:underline" :href="retailerData.retailerWebsite" target="_blank">
                                {{retailerData.retailerWebsite}}
                            </a>
                        </p>
                    </div>
                    <div class="">
                        <p class="mb-1 text-sm font-medium">Boogi generated URL:</p>
                        <p class="w-full py-3 px-2 text-sm bg-white border border-gray-300">
                            <a class="text-sm cursor-pointer hover:underline" :href="transactionData.enrichedCreditorData.website" target="_blank">
                                {{transactionData.enrichedCreditorData.website}}
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <div class="m-2 text-center rounded-xl mt-3 p-2">
                <p class="text-sm font-medium"> Is this brand comptaible with Boogi's transaction
                    matching engine?
                </p>
                <CustomRadio v-model="enrichmentCompatiable" class="text-center justify-center flex"
                    :options="[{ label: 'Yes', id: true }, { label: 'No', id: false }]">
                </CustomRadio>

            </div>
            </div>
        </div>


    </div>
</template>
<script>
import CustomInput from "@/components/inputs/CustomInput.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import CustomRadio from "../inputs/CustomRadio.vue";


export default {
    name: "transaction-mapping",
    components: {
        CustomInput,
        CustomButton,
        CustomRadio
    },
    props:{
        retailerData:{
            type:Object
        }
    },
    data() {
        return {
            enrichmentData: {
                description: this.retailerData.retailerName,
                amount: -100
            },
            enrichmentCompatiable:this.retailerData.obCompatiable == true ? { label: 'Yes', id: true } : undefined,
            transactionData:undefined


        }
    },
    watch:{
        enrichmentCompatiable(val){
            var data = {
                description: this.enrichmentData.description,
                enrichmentCompatiable: val.id
            }
            this.$emit('formSubmit',data)
        }
    },
    methods: {
        async enrichTransaction() {
            const token = localStorage.getItem('token')
            const api = localStorage.getItem('apiType')


            try {
                if (this.enrichmentData.amount > 0) {
                    this.enrichmentData.amount = 0 - this.enrichmentData.amount
                }

                this.loading = true;
                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/bring-your-own-offer/test-enrichment`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `${token}`,
                    },
                    body: JSON.stringify(this.enrichmentData)
                });

                if (response.status === 200) {
                    var responseVal = await response.json()
                    this.transactionData = responseVal

                    if(!this.transactionData.enrichedCreditorData.website.includes("https://"))
                    {
                        this.transactionData.enrichedCreditorData.website = "https://" + this.transactionData.enrichedCreditorData.website

                    }
                    this.demoRequest = {
                        description: "",
                        amount: 0
                    }

                }

            } catch (error) {
                console.log(error)
            }
        }
    }

}
</script>